enum Paths {
    timetable = '/shipping/timetable-slots',
}

export default Paths;



// WEBPACK FOOTER //
// ./src/modules/Timetable/paths.ts